/* HOME-only navigation enhancement. Native Dawn owns the drawer and focus trap.
 * No animation-engine changes, network requests, storage or cart operations. */
(() => {
  'use strict';
  const key = '__noahqHomeShell311';
  if (window[key]) return;
  window[key] = true;
  const mounted = new Map();
  function mount() {
    document.querySelectorAll('header.nqs-header').forEach((header) => {
      if (mounted.has(header)) return;
      const controller = new AbortController();
      const host = header.closest('.section-header');
      let timer;
      const measure = () => {
        const height = host?.offsetHeight;
        if (height > 0) document.documentElement.style.setProperty('--header-height', `${height}px`);
      };
      const observer = window.ResizeObserver && host ? new ResizeObserver(measure) : null;
      observer?.observe(host);
      measure();
      header.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const link = event.target.closest('a[href]');
        const drawer = link?.closest('header-drawer');
        if (!drawer || typeof drawer.closeMenuDrawer !== 'function') return;
        const url = new URL(link.href, location.href);
        if (url.origin !== location.origin || url.pathname !== location.pathname || !url.hash) return;
        let target;
        try { target = document.getElementById(decodeURIComponent(url.hash.slice(1))); } catch (_) { return; }
        const details = drawer.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!target || !summary || !details.open) return;
        event.preventDefault();
        drawer.closeMenuDrawer(event, summary);
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!target.isConnected || !header.isConnected) return;
          location.hash = url.hash;
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
          if (target.hasAttribute('tabindex')) target.focus({ preventScroll: true });
        }, 430);
      }, { signal: controller.signal });
      mounted.set(header, () => { controller.abort(); observer?.disconnect(); clearTimeout(timer); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', (event) => {
    for (const [header, dispose] of mounted) if (event.target.contains(header)) { dispose(); mounted.delete(header); }
  });
})();
